<template>
    <v-content style="padding:0;">

        <v-img
                :style="`margin-top:${topmargin}px;`"

                height="100vh"
        >
            <v-row>
                <v-col cols="12">
                    <v-row style="height:90vh;" justify="center" align="center">
                        <div>
                            <img src="@/assets/frontsketch.png" class="fimg" />
                            <div class="text-center">
                                <v-icon large class="awesome--text">{{icons.sms}}</v-icon>
                                <v-icon  class="awesome--text pa-4">{{icons.plus}}</v-icon>
                                <v-icon large class="awesome--text">{{icons.email}}</v-icon>
                                <v-icon  class="awesome--text pa-4">{{icons.plus}}</v-icon>
                                <v-icon large class="awesome--text">{{icons.group}}</v-icon>
                            </div>
                        </div>
                    </v-row>
                </v-col>
            </v-row>
        </v-img>
        <v-container>
            <v-row>
                <v-col cols="12" sm="12" md="4" v-for="c in cards" :key="c.icon" >
                    <v-row justify="center" align="center">
                        <v-card flat outlined :max-width="maxwidth" class="pt-5 primary " >
                            <div class="text-center">
                                <div :class="`fronticon ${c.icon}`"></div>
                            </div>
                            <v-card-title class="white--text">{{c.title}}</v-card-title>
                            <v-card-subtitle class="white--text">{{c.subtitle}}</v-card-subtitle>
                            <v-card-text class="white--text font-weight-thin cardt">
                                {{c.text}}
                            </v-card-text>
                        </v-card>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>

            <v-row class="black">
                <v-col></v-col>
                <v-col cols="10">
                    <v-list>

                    <v-list-item>
                    <v-list-item-avatar>
                    <v-icon>{{icons.sms}}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                    <v-list-item-title>
                    Your own dedicated number(s)
                    </v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                    <v-list-item-avatar>
                    <v-icon>{{icons.contact}}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                    <v-list-item-title>
                    Unlimited contacts
                    </v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                    <v-list-item-avatar>
                    <v-icon>{{icons.group}}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                    <v-list-item-title>
                    Unlimited groups
                    </v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                    <v-list-item-avatar>
                    <v-icon>{{icons.email}}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                    <v-list-item-title>
                    Emails from multiple addresses
                    </v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                    <v-list-item-avatar>
                    <v-icon>{{icons.voicemail}}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                    <v-list-item-title>
                    Soon - Auto voicemail with delivery and transcribe
                    </v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                    <v-list-item-avatar>
                    <v-icon>{{icons.instagram}}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                    <v-list-item-title>
                    Soon - Post to Intagram
                    </v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                    <v-list-item-avatar>
                    <v-icon>{{icons.paypal}}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                    <v-list-item-title>
                    Soon - Billing customers via Paypal
                    </v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                    <v-list-item-avatar>
                    <Stripe />
                    </v-list-item-avatar>
                    <v-list-item-content>
                    <v-list-item-title>
                    Soon - Billing customers via Stripe
                    </v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>

                    </v-list>

                </v-col>
                <v-col></v-col>
            </v-row>

        <v-container fluid class="py-0">
            <v-row>
                <v-col class="primary">
                    <v-row justify="center" align="center" class="white--text subtitle-2 font-weight-thin">
                            <div class="textappyarrow"></div>
                    </v-row>
                    <v-row justify="center" align="start" class="white--text subtitle-2 font-weight-thin">
                        © 2020 Textappy.io All rights reserved. Psyspider Software.
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>


<script>
  import {
    mapState
  }  from 'vuex'
  import BaseBtn from "@/components/BaseBtn";
  import Stripe from "@/components/icons/Stripe";
  export default {
    components: {Stripe, BaseBtn},
    name: "SplashPage",
    data() {
      return {
        cards:[
          {icon:'arrow1',title:'Direct Engagement',subtitle:'Sms and email direct to your people',text:'Direct contact - send texts to groups and tags, 95% read rate within seconds'},
          {icon:'cloud1',title:'1 TB Drive',subtitle:'Storage for images, video, docs',text:'Upload video, images, docs, attach direct to contacts, send to group. Flyers, events, invitations'},
          {icon:'event1',title:'Events and Invoicing',subtitle:'Create events and invoices',text:'Create events, take registration, use secure checkout, track purchases.. all of it..'}
        ]
      }
    },
    computed: {
      ...mapState(['icons']),
      topmargin(){
        return(this.$vuetify.breakpoint.smAndDown)?'-56':'-64'
      },
      maxwidth(){
        return this.$vuetify.breakpoint.smAndDown?380:280
      }
    },
    mounted() {
    },
    methods: {
      loadReviews(){
        this.$store.dispatch('openPost',)
      }
    }
  }
</script>

<style scoped>
    @media screen and (max-width: 960px){
        .fimg{
            width:400px;
            height:400px;
        }
    }
    @media screen and  (max-width: 600px){
        .fimg{
            width:300px;
            height:350px;
        }
    }

    @media screen and  (min-width: 961px){
        .fimg{
            margin-top:30px;
            width:460px;
            height:460px;
        }
    }
    @media screen and (min-width: 1020px){
        .fimg{
            width:600px;
            height:500px;
        }
    }
    .cardt{
        height: 85px;
    }
    .arrow1{
        background-image: url('../../assets/fontarrow1.svg');
    }
    .cloud1{
        background-image: url('../../assets/cloudarrow1.svg');
    }
    .event1{
        background-image: url('../../assets/eventarrow1.svg');
    }
    .textappyarrow{
        background-image: url('../../assets/textappyarrow.svg');
        width:100px;
        height:100px;
        display:inline-block;
    }
</style>